import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  storeSpecificWindowData,
  resetInterWindow,
  selectWindowDataList,
  deleteSpecificWindow,
} from "@src/@slice/interWindowSlice";
import { isExternalUrl } from "..";

export const useInterWindow = ({
  id,
  receiverId,
  needResetData = true,
  callBackWhenBackToOriginalWindow,
}: {
  id: string;
  receiverId: string;
  needResetData?: boolean;
  callBackWhenBackToOriginalWindow?: () => void;
}) => {
  const dispatch = useDispatch();
  const ForWindowDataList = useSelector(selectWindowDataList);
  const isOpen = useRef(false);
  const [link, setLink] = useState<{ url: string; hidetop?: boolean; hidesafearea?: boolean }>({
    url: "",
  });

  const resetWindow = () => {
    dispatch(resetInterWindow());
  };

  const openWindow = (
    windowData: any,
    link: {
      url: string;
      hidetop?: boolean;
      hidesafearea?: boolean;
    },
  ) => {
    dispatch(storeSpecificWindowData({ id: id, receiverIdList: [receiverId] }));
    dispatch(
      storeSpecificWindowData({
        id: receiverId,
        data: windowData,
        senderIdList: [id],
      }),
    );
    setLink(link);
  };

  useEffect(() => {
    if (isOpen.current === false && link?.url) {
      isOpen.current = true;
      window.location.href = isExternalUrl(
        `${link.url}${link.url.indexOf("?") > -1 ? "&" : "?"}hidetop=${link.hidetop}`,
      );
    }
  }, [link?.url]);

  // 새창에서 원래창으로 돌아왔을 때 처리
  const timerIdRefForVisibilityChange = useRef<NodeJS.Timeout | null>(null);

  const handleVisibilityChange = useCallback(() => {
    if (!document.hidden) {
      if (timerIdRefForVisibilityChange.current)
        clearTimeout(timerIdRefForVisibilityChange.current);
      timerIdRefForVisibilityChange.current = setTimeout(() => {
        if (ForWindowDataList[receiverId] !== undefined) {
          dispatch(deleteSpecificWindow({ id: receiverId }));
        }
        if (needResetData) {
          if (ForWindowDataList[id] !== undefined) {
            dispatch(deleteSpecificWindow({ id: id }));
          }
        }
        isOpen.current = false;
        setLink({ url: "" });
        callBackWhenBackToOriginalWindow && callBackWhenBackToOriginalWindow();
      }, 300);
    }
  }, [ForWindowDataList]);

  useEffect(() => {
    if (ForWindowDataList?.[id]) {
      window.addEventListener("visibilitychange", handleVisibilityChange);
    }
    return () => {
      if (ForWindowDataList?.[id]) {
        window.removeEventListener("visibilitychange", handleVisibilityChange);
      }
    };
  }, [ForWindowDataList?.[id]]);

  return { openWindow, resetWindow, isOpen };
};
